// UI Interaction Constants
export const DOUBLE_CLICK_PREVENTION_MS = 500;
export const PAYMENT_DOUBLE_CLICK_WINDOW_MS = 3000;
export const HAPTIC_VIBRATION_MS = 50;
export const MIN_TOUCH_DURATION_MS = 50;
export const MAX_PIN_CONFIRM_ATTEMPTS = 3;
export const PIN_ERROR_DISPLAY_MS = 1500;
// Must match the @keyframes shake duration in PinCode/styles.module.css.
export const PIN_SHAKE_ANIMATION_MS = 400;
export const WRONG_PIN_HTTP_STATUS = 401;

// Unit Conversion Constants
export const WATTS_PER_KILOWATT = 1000;

// Time Conversion Constants
export const MS_PER_SECOND = 1000;
export const SECONDS_PER_MINUTE = 60;
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
